import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from '@axa-asia/emma-stylesheet/lib/components/Dialog';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { signOut } from '../../../../actions/authActions';
import { goto } from '../../../../actions/historyActions';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import LoadingView from '../../../../components/LoadingView';
import {
  getCustomer,
  getCustomerIconGender,
} from '../../../../selectors/userSelectors';
import { extractRelativeUrl, resolveLocalizedText } from '../../../../utils';
import { isMobileWeb } from '../../../../utils/index';
import { fetchCustomerPermissions } from '../../actions/customerProfileAction';
import BackNavButton from '../../components/BackNavButton';
import CustomerProfileInformation from '../../components/CustomerProfileInformation';
import { CustomerProfileSetting } from '../../components/CustomerProfileSetting';
import CustomerProfileTool from '../../components/CustomerProfileTool';
import {
  CHANGE_CONTACT_ID,
  SLIDER_ITEM_OFFSET_WIDTH,
} from '../../constants/constants';
import {
  getCustomerLastUpdateDate,
  getCustomerProfileFeaturesApi,
  getCustomerProfileFeaturesConfig,
  getCustomerProfileLabelsConfig,
  getCustomerProfileLoading,
  getCustomerProfileModalConfig,
  getCustomerSettingFeaturesApi,
  getCustomerSettingFeaturesConfig,
} from '../../selectors/customerProfileSelectors';
import {
  customerSettingFeaturesService,
  customerToolFeaturesService,
  profileModal,
} from '../../types/customerSettingFeaturesService';
import './style.scss';

const CHANGE_CONTACT_HASH = '#changecontact';

export interface CustomerProfileContainerProps {
  customerName: string;
  profileFeaturesConfig: Array<any>;
  settingFeaturesConfig: Array<any>;
  profileFeatures: Array<any>;
  settingFeatures: Array<any>;
  onFetchCustomerPermissions: () => void;
  onSignOut: () => void;
  title: string;
  moreSettings: string;
  lastUpdated: string;
  logoutButton: string;
  customerIconGender: string;
  profileModalConfig: profileModal;
  isLoading: boolean;
  lastUpdateDate: string;
}

export interface CustomerProfileContainerState {
  isShowBackButton: boolean;
  curSliderIndex: number;
  isShowModal: boolean;
  curCustomerProfile: any;
  changeContact: boolean;
  triggeredChangeContact: boolean;
}

export class CustomerProfileContainer extends Component<
  CustomerProfileContainerProps,
  CustomerProfileContainerState
> {
  constructor(props: any) {
    super(props);
    const url = new URL(location.href);
    const changeContact = url.hash === CHANGE_CONTACT_HASH;
    this.state = {
      isShowBackButton: false,
      curSliderIndex: 0,
      isShowModal: false,
      curCustomerProfile: null,
      changeContact,
      triggeredChangeContact: false,
    };
    this.onHideModal = this.onHideModal.bind(this);
    this.onShowModal = this.onShowModal.bind(this);
    this.onGoView = this.onGoView.bind(this);
  }

  onGoView() {
    const { curCustomerProfile } = this.state;
    const url = _.get(curCustomerProfile, `deepLink.query.url`, '');
    url && goto(url);
  }

  componentDidMount() {
    this.props.onFetchCustomerPermissions();
    const relativeUrl = extractRelativeUrl();
    const segments = relativeUrl.split(`/`).filter((s) => !!s);
    const isShowBackButton =
      _.lastIndexOf(segments, 'customerprofile') == 0 && segments.length == 1
        ? true
        : false;
    this.setState({ isShowBackButton: isShowBackButton });
    if (this.state.changeContact) {
      this.onShowChangeContactModal();
    }
  }

  componentDidUpdate(prevProps: Readonly<CustomerProfileContainerProps>): void {
    if (
      prevProps.profileFeatures !== this.props.profileFeatures &&
      this.props.profileFeatures.length > 0
    ) {
      if (this.state.changeContact && !this.state.triggeredChangeContact) {
        this.onShowChangeContactModal();
      }
    }
  }

  logout() {
    const { onSignOut } = this.props;
    onSignOut();
  }

  onHideModal() {
    this.setState({ isShowModal: false });
  }

  onShowChangeContactModal() {
    const featureConfig = this.props.profileFeaturesConfig.find(
      (featureConfig) => featureConfig.id === CHANGE_CONTACT_ID,
    );
    if (!featureConfig) return;
    if (
      this.props.profileFeatures &&
      this.props.profileFeatures.includes(CHANGE_CONTACT_ID)
    ) {
      const newUrl = new URL(window.location.href);
      newUrl.hash = '';
      window.history.replaceState(null, '', newUrl);
      this.setState({ triggeredChangeContact: true });
      this.onShowModal(featureConfig);
    }
  }

  onShowModal(curCustomerProfile: any) {
    this.setState({ curCustomerProfile }, () => {
      const { curCustomerProfile } = this.state;
      if (curCustomerProfile && curCustomerProfile.id === CHANGE_CONTACT_ID) {
        this.setState({ isShowModal: true });
      } else {
        this.onGoView();
      }
    });
  }

  getIsShowSlider() {
    const slickWrap =
      document &&
      document.getElementsByClassName(
        'customer-profile-container__tool-content',
      )[0];
    const slickItems =
      document &&
      document.getElementsByClassName(
        'customer-profile-container__tool-content-item',
      );
    const slickItemsLength = (slickItems && slickItems.length) || 0;
    const slickWrapWidth = (slickWrap && slickWrap.clientWidth) || 0;
    const slickItemsWidth = SLIDER_ITEM_OFFSET_WIDTH * slickItemsLength;
    return slickItemsWidth > slickWrapWidth;
  }

  render() {
    const isShowSlider = this.getIsShowSlider();
    const { isShowBackButton, curSliderIndex, isShowModal } = this.state;
    const {
      customerName,
      settingFeaturesConfig,
      profileFeaturesConfig,
      profileFeatures,
      settingFeatures,
      title,
      moreSettings,
      lastUpdated,
      logoutButton,
      customerIconGender,
      profileModalConfig,
      isLoading,
      lastUpdateDate,
    } = this.props;
    const customerProfileInformationProps = {
      customerName,
      customerIconGender,
    };
    const defaultSliderSettings = {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1.8,
      centerMode: false,
      variableWidth: false,
      arrows: false,
      afterChange: (index: number) => {
        const i = Math.ceil(index);
        this.setState({ curSliderIndex: i });
        const dotLi = document
          .getElementsByClassName('slick-dots')[0]
          .getElementsByTagName('li');
        if (i !== index) {
          dotLi[i].classList.add('slick-active');
        } else {
          dotLi.length &&
            dotLi.length - 1 > -1 &&
            dotLi[dotLi.length - 1].classList.remove('slick-active');
        }
      },
    };
    const customerProfileTool = profileFeaturesConfig.map(
      (toolService: customerToolFeaturesService, index: number) => {
        return (
          profileFeatures.includes(toolService.id) && (
            <div
              data-enable-ga
              data-ga-type="button"
              className="customer-profile-container__tool-content-item"
              key={index}
              onClick={() => this.onShowModal(toolService)}
            >
              <CustomerProfileTool
                isShowSlider={isShowSlider}
                {...toolService}
                isActive={curSliderIndex === index && isShowSlider}
              />
            </div>
          )
        );
      },
    );

    return isLoading ? (
      <LoadingView />
    ) : (
      <div className="customer-profile-container">
        {isShowBackButton && (
          <div className="customer-profile-backbutton">
            <BackNavButton />
          </div>
        )}
        <div className="emma-stylesheet-grid-system">
          <div className="customer-profile-container__title">{title}</div>
          <CustomerProfileInformation {...customerProfileInformationProps} />
          <div className="customer-profile-container__tool-content emma-deprecated-slick">
            {isShowSlider ? (
              <Slider {...defaultSliderSettings}>{customerProfileTool}</Slider>
            ) : (
              <div className="content-align-level">{customerProfileTool}</div>
            )}
            <div className="customer-profile-container__tool-content-update-time">
              {lastUpdated &&
                lastUpdateDate &&
                lastUpdated.replace(
                  '${lastUpdatedDate}',
                  moment(lastUpdateDate.split(' ')[0]).format('YYYY/MM/DD'),
                )}
            </div>
          </div>
          <div className="customer-profile-container__setting-content">
            {/*<div className='customer-profile-container__setting-content-title'>*/}
            {/*  {moreSettings}*/}
            {/*</div>*/}
            <div className="content-align-level-right-wrap">
              {settingFeaturesConfig
                // Disable feedback for web temporary
                .filter((service) => service.id !== 'feedback')
                .map(
                  (service: customerSettingFeaturesService, index: number) => {
                    return (
                      settingFeatures.includes(service.id) && (
                        <div
                          data-enable-ga
                          data-ga-type="button"
                          className="customer-profile-container__setting-content-item"
                          key={index}
                        >
                          <CustomerProfileSetting {...service} />
                        </div>
                      )
                    );
                  },
                )}
            </div>
          </div>
          {isMobileWeb() && (
            <div className="customer-profile-container__logout content-align-vertical">
              <div
                data-enable-ga
                data-ga-type="button"
                className="customer-profile-container__logout-button content-align"
                onClick={() => this.logout()}
              >
                {logoutButton}
              </div>
            </div>
          )}
        </div>
        <Dialog show={isShowModal} onHide={this.onHideModal}>
          <DialogHeader>
            <span>
              {profileModalConfig.title
                ? resolveLocalizedText(profileModalConfig.title)
                : ''}
            </span>
          </DialogHeader>
          <DialogBody>
            <div>
              {profileModalConfig.desc1
                ? resolveLocalizedText(profileModalConfig.desc1)
                : ''}
            </div>
            <div className="mt24">
              {profileModalConfig.desc2
                ? resolveLocalizedText(profileModalConfig.desc2)
                : ''}
            </div>
          </DialogBody>
          <DialogFooter>
            <div className="dailog-footer-btn-align__center">
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-default-button"
                onClick={() => {
                  this.onHideModal();
                  this.onGoView();
                }}
              >
                {profileModalConfig.button && profileModalConfig.button.label
                  ? resolveLocalizedText(profileModalConfig.button.label)
                  : ''}
              </button>
            </div>
          </DialogFooter>
        </Dialog>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const customer = getCustomer(state);
    const profileLabels = getCustomerProfileLabelsConfig(state);
    const welcomeGuest =
      profileLabels && profileLabels.welcomeGuest
        ? resolveLocalizedText(profileLabels.welcomeGuest)
        : '';
    const lastUpdateDate = getCustomerLastUpdateDate(state);
    return {
      customerName:
        customer && customer.englishName ? customer.englishName : welcomeGuest,
      profileFeaturesConfig: getCustomerProfileFeaturesConfig(state),
      settingFeaturesConfig: getCustomerSettingFeaturesConfig(state),
      profileFeatures: getCustomerProfileFeaturesApi(state),
      settingFeatures: getCustomerSettingFeaturesApi(state),
      profileModalConfig: getCustomerProfileModalConfig(state),
      title: profileLabels.title
        ? resolveLocalizedText(profileLabels.title)
        : '',
      moreSettings: profileLabels.moreSettings
        ? resolveLocalizedText(profileLabels.moreSettings)
        : '',
      lastUpdated: profileLabels.lastUpdated
        ? resolveLocalizedText(profileLabels.lastUpdated)
        : '',
      logoutButton: profileLabels.logoutButton
        ? resolveLocalizedText(profileLabels.logoutButton)
        : '',
      customerIconGender: getCustomerIconGender(state),
      isLoading: getCustomerProfileLoading(state),
      lastUpdateDate,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onFetchCustomerPermissions: () => dispatch(fetchCustomerPermissions()),
      onSignOut: () => dispatch(signOut()),
    };
  }
}

export default connect(
  CustomerProfileContainer.mapStateToProps,
  CustomerProfileContainer.mapDispatchToProps,
)(CustomerProfileContainer);
